<div class="row">
  <div class="col-12 doble mb-4"></div>

  <div class="col-4">
    <h3 class="text-center">
      {{conf.name}}
    </h3>
    <p>
      <b><i class="fas fa-phone" aria-hidden="true"></i> Telefono: </b>{{conf.tel}}
    </p>
    <p>
      <b><i class="fas fa-map-marker" aria-hidden="true"></i> Dirección: </b>
      {{conf.dir}}
    </p>
  </div>
  <div class="col-4">
    <h1 class="text-center text-x">
      X
    </h1>
  </div>
  <div class="col-4">
    <h3 class="text-center">
      PROFORMA
    </h3>
    <h5>
      N° {{zfill(1,4) }}-{{zfill(item.id,8) }}
    </h5>
    <div class="row">
      <label for="" class="col-3 mt-2">
        Fecha:
      </label>
      <div class="datete col-2">
        {{item.created_at | date:'dd'}}
      </div>
      <div class="datete col-2">
        {{item.created_at | date:'MM'}}
      </div>
      <div class="datete col-2">
        {{item.created_at | date:'yy'}}
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="col-12 doble mb-4"></div>
    <div class="text-left">
      <p class="col-12 dotter">
        <b>Nombre:</b> {{item.cliente | uppercase }}
      </p>
      <p class="col-12 dotter">
        <b>Condición de pago:</b> {{ item.condicion | uppercase}}
      </p>
    </div>
  </div>
  <div class="col-12">
    <table class="table table-sm table-bordered  table-striped">
      <thead>
        <tr>
          <th class="col-1">Cantidad</th>
          <th class="col-6">Descripción</th>
          <th class="col-1">Precio/Unitario</th>
          <th class="text-right col-1">Sub Total</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of detalle">
          <td scope="row">{{item.cantidad}}</td>
          <td>{{item.mercaderia.nombre}}</td>
          <td class="text-right">$ {{item.precio}}</td>
          <th class="text-right">$ {{item.precio * item.cantidad}}</th>
        </tr>
        <tr>
          <td class="text-right" scope="row" colspan="2">
            <h4><b> Total</b></h4>
          </td>
          <td class="text-right" colspan="2">
            <label for="" style="font-size: 1.5em;">
              <b>{{ item.total | number:'1.2-2' }}</b>
            </label>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="col-12 text-center">
    <label>
      Documento no valido como factura
    </label>
  </div>
</div>